import { useLocale } from "next-intl";
import { LocaleSwitcherSelect } from "./locale-switcher-select";

interface LocaleSwitcherProps {
  isMainPage: boolean;
  isScrolled: boolean;
  setIsHovered: (isHovered: boolean) => void;
}

export function LocaleSwitcher({ isMainPage, isScrolled, setIsHovered }: LocaleSwitcherProps) {
  const isTransparentTheme = isMainPage && !isScrolled;

  const locale = useLocale();

  return <LocaleSwitcherSelect isTransparentTheme={isTransparentTheme} locale={locale} setIsHovered={setIsHovered} />;
}
